import { GLBModel } from "@/scene/GLBModel";
import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import {
  CLARET_WIGGLE_SEAWEED_MODEL,
  CORAL_MODELS,
  LOG_MODEL,
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
} from "./shared";
import { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";

// Неоны (#30) — Микропластик: стаканчик, вилка, шарик
export const NEONS_GARBAGE_MODELS = [
  new GLBModel("/models/garbage/02_blue_glass.glb"),
  new GLBModel("/models/garbage/fork.glb"),
  new GLBModel("/models/garbage/baloon.glb"),
];

export const NEONS_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: 2, y: -2.28, z: -3.7 },
    rotation: { x: -1.746, y: 1.151, z: -3.141 },
    scale: { x: 1.95, y: 1.75, z: 1.85 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: 0.88, y: -2.29, z: 1.18 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 1.35,
    position: { x: -0.18, y: -2.28, z: 1.62 },
    rotation: { x: 0.04, y: -0.78, z: 0.06 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.18, y: -2.28, z: 3 },
    rotation: { x: 0, y: -0.524, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 3, y: -2, z: 0.36 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 1.07,
    position: { x: 2, y: -2.27, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CLARET_WIGGLE_SEAWEED_MODEL,
    targetSize: 0.7,
    position: { x: 0, y: -2.28, z: -3.4 },
    rotation: { x: -3.142, y: 0.349, z: -3.142 },
    scale: { x: 2.45, y: 4.3, z: 2.65 },
  },
  {
    model: CLARET_WIGGLE_SEAWEED_MODEL,
    targetSize: 0.7,
    position: { x: -2.05, y: -2.35, z: -1.35 },
    rotation: { x: 0, y: -0.96, z: 0 },
    scale: { x: 2, y: 3.35, z: 2.2 },
  },
  {
    model: CLARET_WIGGLE_SEAWEED_MODEL,
    targetSize: 0.7,
    position: { x: 1.45, y: -2.5, z: -2 },
    rotation: { x: 0, y: 0.785, z: 0 },
    scale: { x: 1.85, y: 2.05, z: 1.5 },
  },
  {
    model: CORAL_MODELS[0],
    targetSize: 0.7,
    position: { x: 0, y: -2.28, z: -2.05 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: -3.15, y: -2.45, z: -3.25 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[7],
    targetSize: 0.7,
    position: { x: -2.15, y: -2.55, z: -3.35 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.4, y: 5.8, z: 2.25 },
  },
  {
    model: CORAL_MODELS[8],
    targetSize: 0.7,
    position: { x: -3.75, y: -2.28, z: -1.85 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.3, y: 9.25, z: 1.6 },
  },
  {
    model: CORAL_MODELS[9],
    targetSize: 0.7,
    position: { x: -0.05, y: -2.35, z: -3.45 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.4, y: 2.45, z: 1 },
  },
  {
    model: CORAL_MODELS[10],
    targetSize: 0.7,
    position: { x: 3.75, y: -2.45, z: -1.85 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.75, y: 3, z: 2.55 },
  },
  {
    model: CORAL_MODELS[11],
    targetSize: 0.7,
    position: { x: -2.65, y: -2.65, z: -2.6 },
    rotation: { x: -3.142, y: 0.349, z: -3.142 },
    scale: { x: 1.7, y: 2.4, z: 1.4 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 2.75, y: -2.65, z: -4.65 },
    rotation: { x: -3.142, y: -1.309, z: -3.142 },
    scale: { x: 4.25, y: 6.65, z: 3.4 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 1.1, y: -2.55, z: -4.15 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 3.85, y: 3.4, z: 1 },
  },
];

export const NEONS_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  pollutionColor: "#827f65",
};
